/**
 * The password somebody just typed, held for the one sign-in the emailed code completes.
 *
 * The ad funnel was: email and password, the code from the email, and then an EMPTY Sign in form
 * asking for both again (F7, 2026-09-30). Confirming a sign-up proves the email; it does not sign
 * anybody in, so the password has to be presented once more, and this is the page presenting it
 * rather than the person.
 *
 * In this module's memory and nowhere else. Never router state, which the browser writes into its
 * history entry and keeps across reloads; never storage. Taken exactly once — `take` clears it —
 * and only for the email it was typed with, and forgotten after HOLD_MS, so a tab left open does
 * not keep it for the next person at the keyboard. A reload loses it, which is the point: the
 * person is then asked to sign in, with the email filled.
 */
const HOLD_MS = 30 * 60 * 1000;

let held: { email: string; password: string; at: number } | null = null;

const key = (email: string): string => email.trim().toLowerCase();

export function holdPassword(email: string, password: string): void {
  held = { email: key(email), password, at: Date.now() };
}

/** The password held for `email`, once; null for any other email, or once it has gone. */
export function takePassword(email: string): string | null {
  const now = held;
  held = null;
  if (!now || now.email !== key(email) || Date.now() - now.at > HOLD_MS) return null;
  return now.password;
}
